"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyNow = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const baseLibrary_1 = require("../baseLibrary");
class MbVerifyNow extends baseLibrary_1.BaseLibrary {
    constructor(verifyNowId) {
        super();
        this.verifyNowId = verifyNowId;
    }
    async load() {
        if (window.VERIFY_NOW_URL && window.VERIFY_NOW_URL.trim()) {
            const verifyNowUrl = new URL(window.VERIFY_NOW_URL);
            if (this.verifyNowId) {
                verifyNowUrl.searchParams.append('homeId', this.verifyNowId);
            }
            this.instance = new web_ui_framework_1.VerifyNow(verifyNowUrl.href);
            await this.instance.load();
        }
        else {
            web_ui_framework_1.Log.warn('VerifyNow: There is no valid VERIFY_NOW_URL configured');
        }
    }
}
exports.VerifyNow = MbVerifyNow;
//# sourceMappingURL=index.js.map